import React from "react";
import { cn } from "../../lib/cn";

const Section = ({ id, className, children }) => {
  return (
    <section id={id} className={cn("mx-auto max-w-6xl px-4", className)}>
      {children}
    </section>
  );
};

export default Section;
